import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { cssVariables } from '@env/css-vars';
import { TranslateService } from '@ngx-translate/core';
import { NotificationDialogComponent } from '../dialog/notification-dialog/notification-dialog.component';
import { OverlayLoaderService } from './overlay-loader.service';

@Injectable({
  providedIn: 'root',
})
export class VirusScannerService {
  constructor(
    public translate: TranslateService,
    private matDialog: MatDialog,
    private overlayLoader: OverlayLoaderService,
  ) {}

  public errorChecker(err: any) {
    this.overlayLoader.isLoading = false;
    if (err.status === 400 && err.error.AppErrorCode === 1) {
      this.matDialog.open(NotificationDialogComponent, {
        data: {
          descriptionText: this.translate.instant(`module.antiVirusScanner.virusDetectedMessage`),
          descriptionFaClass: 'fa-exclamation-triangle fa-2x',
          descriptionFaColor: cssVariables['--ep-error-color'],
          confirmText: this.translate.instant(`module.antiVirusScanner.virusDetectedBackToUpload`),
          declineText: this.translate.instant(`module.antiVirusScanner.virusDetectedCancel`),
        },
        panelClass: ['-md'],
      });
    } else if (err.status === 500 || err.status === 503 || err.status === 502) {
      this.matDialog.open(NotificationDialogComponent, {
        data: {
          descriptionText: this.translate.instant(`module.antiVirusScanner.serverErrorMessage`),
          descriptionFaClass: 'fa-exclamation-triangle fa-2x',
          descriptionFaColor: cssVariables['--ep-error-color'],
          confirmText: this.translate.instant(`module.antiVirusScanner.serverErrorTryAgain`),
        },
        panelClass: ['-md'],
      });
    } else {
      this.matDialog.open(NotificationDialogComponent, {
        data: {
          descriptionText: this.translate.instant(`module.antiVirusScanner.serverErrorMessage`),
          descriptionFaClass: 'fa-exclamation-triangle fa-2x',
          descriptionFaColor: cssVariables['--ep-error-color'],
        },
        panelClass: ['-md'],
      });
    }
  }
}
